/*@flow*/
import type { RefinementType } from './types.js';
import refinement from './refinement';
import Number from './Number';

export default (): RefinementType =>
  refinement(Number, (x: number) => x % 1 === 0, 'Integer');
